module.exports = __webpack_public_path__ + "img/hr-tree-06-e-trunk.82a7ebe8.png";